import { rankingItems } from '@/mocks/homeData';

export default function RankingSection() {
  return (
    <section id="ranking" className="py-10 md:py-14 bg-background-100/60">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="flex items-center justify-between mb-8">
            <div>
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-2">人气排行</h2>
              <p className="text-sm text-foreground-500">最受读者欢迎的热门漫画作品</p>
            </div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {rankingItems.map((item) => (
              <div
                key={item.rank}
                className="flex items-center gap-4 p-4 bg-background-50 border border-background-200/70 rounded-xl hover:border-primary-200 transition-all duration-300 cursor-pointer"
              >
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100/70 text-primary-600 font-heading font-bold text-lg shrink-0">
                  {item.rank}
                </div>
                <div className="flex-1 min-w-0">
                  <h3 className="font-heading text-sm font-semibold text-foreground-900 truncate">{item.title}</h3>
                  <p className="text-xs text-foreground-500 mt-0.5">{item.author} · {item.category}</p>
                </div>
                <div className="text-right shrink-0">
                  <p className="text-sm font-semibold text-accent-600">{item.views}</p>
                  <p className={`text-xs mt-0.5 ${item.status === '连载中' ? 'text-primary-500' : 'text-foreground-400'}`}>
                    {item.status}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}